<ng-container >
    <div class="pt-2 pb-4">
        <a [routerLink]="['/home']" class="ls-p-extra-small underlined"
            [ngClass]="{
                'text-brand-10': isSecondLevelUp,
                'text-neutral-A1': !isSecondLevelUp
            }"
        > Home 
        </a>
        <span [ngClass]="{
            'text-brand-10': isSecondLevelUp,
            'text-neutral-A1': !isSecondLevelUp
        }" class="ls-p-extra-small"> / </span>
        <ng-container *ngFor="let voice of newBreadcrumb; let i = index">
            <a [ngClass]="{
                'underlined' : i !== (newBreadcrumb.length - 1),
                'text-neutral-A1': (i !== newBreadcrumb.length - 1) && !isSecondLevelUp,
                'text-neutral-80': (i === newBreadcrumb.length - 1) && !isSecondLevelUp,
                'text-neutral-10': (i !== newBreadcrumb.length - 1) && isSecondLevelUp,
                'text-neutral-50': (i === newBreadcrumb.length - 1) && isSecondLevelUp
            }"
                [routerLink]="navigationService.splitUrlRouterLink(voice.link).path"
                [queryParams]="navigationService.splitUrlRouterLink(voice.link).queryParams" class="ls-p-extra-small"
                 [innerHTML]="voice.label">
            </a>
            <span *ngIf="i < (newBreadcrumb.length-1)"
                [ngClass]="{
                    'text-neutral-50': isSecondLevelUp,
                    'text-neutral-A1': !isSecondLevelUp
                }" class="ls-p-extra-small"> / </span>
        </ng-container>
            </div>
</ng-container>